import { render, staticRenderFns } from "./participant.vue?vue&type=template&id=ccfabd4c&scoped=true&"
import script from "./participant.vue?vue&type=script&lang=js&"
export * from "./participant.vue?vue&type=script&lang=js&"
import style0 from "./participant.vue?vue&type=style&index=0&id=ccfabd4c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccfabd4c",
  null
  
)

export default component.exports